// extracted by mini-css-extract-plugin
export var col = "Media__col-gUnKc";
export var date = "Media__date-hoUOM";
export var title = "Media__title-GMe6i";
export var wrapper = "Media__wrapper-fuhBT";